// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.epKfUgtWMLaRSA {
  flex: 1 0;
  padding: var(--ds-space-025, 2px) var(--ds-space-100, 8px);
  border: 1px solid transparent;
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--ds-background-neutral, #091e420f);
}
.epKfUgtWMLaRSA span {
  display: block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.epKfUgtWMLaRSA:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
.xIMrWE_y9grD0F {
  border: 1px solid var(--ds-border-selected, #0c66e4);
  background-color: var(--ds-background-selected, #e9f2ff);
  color: var(--ds-text-selected, #0c66e4);
}
.xIMrWE_y9grD0F:hover {
  background-color: var(--ds-background-selected-hovered, #cce0ff);
}
.v1Zqz83vu9ZgZB {
  margin-right: var(--ds-space-050, 4px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `epKfUgtWMLaRSA`,
	"selected": `xIMrWE_y9grD0F`,
	"lockIcon": `v1Zqz83vu9ZgZB`
};
export default ___CSS_LOADER_EXPORT___;
